import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import CButton from "../CButton/CButton";

// Codex WARNING fix: migrated this component off @material-ui/core (v4) onto
// @mui/material (v5) so the repo no longer drags both MUI majors in. v4
// makeStyles + theme.spacing tuple replaced with v5 sx + theme.spacing()
// callable. Public component API unchanged — props {title, isLoading,
// setOpen, handleClick} are still consumed identically.

const ConformationModel = (props) => {
  const handleClose = (filter) => {
    if (filter === "cancel") {
      return props.setOpen(false);
    }
    if (filter === "done") {
      props.handleClick();
    }
  };

  return (
    <Box
      // Centred via translate so the consumer can drop this anywhere
      // (typically inside a <Modal>) without supplying positioning.
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: 400,
          maxWidth: "90vw",
          bgcolor: "background.paper",
          p: (theme) => theme.spacing(2, 4, 3),
          textAlign: "center",
        }}
      >
        <Typography
          id="confirmation-modal-title"
          variant="h6"
          component="h2"
          sx={{ mb: 2, fontWeight: 700 }}
        >
          {props.title}
        </Typography>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <CButton
            Width={100}
            Padding="12px 0px"
            title={props.isLoading ? "Loading.." : "Yes"}
            backGroundColor="rgb(0, 158, 247)"
            Color="#fff"
            onClick={() => handleClose("done")}
            filter="close"
            disabled={props.isLoading}
          />
          <CButton
            Width={100}
            Padding="12px 0px"
            title={"Cancel"}
            backGroundColor="rgba(210,68,68,1)"
            Color="#ffff"
            onClick={() => handleClose("cancel")}
            filter="close"
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default ConformationModel;
